import { Stack, Button, Link } from "@mui/material";
import { Store, Course } from "../api/ApiData";
import { ColorHexCodes } from "../util/Color";
import { useYesNoDialog, useYesNoDialogArgs } from "./YesNoDialog";
import { StyledText } from "./StyledText";
import ReservationSummary from "./ReservationSummary";
import Time from "../util/Time";
import { useState } from "react";
import { useApiContext } from "../api/ApiProvider";

export default function CancellableReservationSummary({ data }: { data: { rid: string; store: Store; nominated_staff_name: string | undefined; course: Course; date: number; name: string; phone: string; mail: string; request: string } }) {
  const { api } = useApiContext();
  const [isCancelled, setIsCancelled] = useState(false);
  const cancelDialog = useYesNoDialog();
  let cancelMessage = <></>;
  let cancellable = true;
  let showCancelButton = true;

  const currentTime = Time.Now().getTime();
  const cancelDialogParam: useYesNoDialogArgs = {
    title: "予約キャンセル確認",
    text: "本当にキャンセルしますか？キャンセル料金は発生しません。",
    onSubmit: (e) => {
      if (e) {
        api.deleteReservation(data.rid).then((statusData) => setIsCancelled(statusData != null));
      }
    },
  };

  if (data.store) {
    if (isCancelled) {
      cancelMessage = (
        <Stack>
          <StyledText textStyle="CancelText">{"予約はキャンセルされました。"}</StyledText>
          <Stack direction="row">
            <StyledText textStyle="CancelText">再予約を行う場合は</StyledText>
            <Link href={`/reserve/?shop=${data.store.id}&course=${data.course.id}`} color={`#${ColorHexCodes.Blue}`}>
              こちら
            </Link>
            <StyledText textStyle="CancelText">から</StyledText>
          </Stack>
        </Stack>
      );
      cancellable = false;
    } else if (data.store.cancel_grace > 0 && currentTime < data.date) {
      const cancelableHour = Math.ceil(data.store.cancel_grace / Time.AnHour);
      cancelMessage = <StyledText textStyle="CancelText">{`施術開始時刻の${cancelableHour}時間前までキャンセル可能です。`}</StyledText>;
      cancellable = currentTime + data.store.cancel_grace < data.date;
    } else {
      cancelMessage = <StyledText textStyle="CancelText">{"この予約はキャンセルできません。"}</StyledText>;
      showCancelButton = false;
    }
  }

  return (
    <Stack gap={1}>
      <ReservationSummary data={data} />
      <div style={{ height: 1, width: "100%", background: `#${ColorHexCodes.MainColorGreen}` }} />
      {cancelMessage}
      <Stack alignItems="center" display={showCancelButton ? "" : "none"}>
        <Button variant="contained" color="error" disabled={!cancellable} sx={{ minHeight: "40px", width: "30%", minWidth: "150px" }} onClick={() => cancelDialog.show(cancelDialogParam)}>
          予約をキャンセル
        </Button>
      </Stack>
      {cancelDialog.dialog}
    </Stack>
  );
}
